import { render, staticRenderFns } from "./list_categories_component.vue?vue&type=template&id=de3fe8a4&scoped=true"
import script from "./list_categories_component.vue?vue&type=script&lang=js"
export * from "./list_categories_component.vue?vue&type=script&lang=js"
import style0 from "./list_categories_component.vue?vue&type=style&index=0&id=de3fe8a4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3fe8a4",
  null
  
)

export default component.exports